import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoticeModal from "views/components/NoticeModal";
import { saveAuthData, saveUserData } from "store/reducers/login/LoginSlice";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import uuid from 'react-uuid';
import ToastModal from "views/components/ToastModal";
import CircularProgresss from "components/CircularProgress/CircularProgresss";

const AutoLogin = () => {
  const navigate = useNavigate();
  const { autoId } = useParams();
  const dispatch = useDispatch();

  const [noticeModal, setNoticeModal] = useState(false);
  const [noticeModalErrMsg, setNoticeModalErrMsg] = useState("");
  const [noticeModalHeaderMsg, setNoticeModalHeaderMsg] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [callInProgress,setCallInProgress]=useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  const closeNoticeModal = () => {
    setNoticeModal(false);
    setNoticeModalErrMsg("");
    setNoticeModalHeaderMsg("");
  };

  useEffect(() => {
    autoLogin();
  }, []);

  const isAuthenticated = useSelector(state => state.login.authData?.isAuthenticated);

  const autoLogin = async () => {
    setCallInProgress(true)
    const result = await apiHandler({
      url: endpoint.RETAIN_TOKEN + autoId,
    });
    setCallInProgress(false)
    if (result?.data?.error_code) {
      console.log("Error in Auto Login");
    } else {
      if(result?.data?.access_token){
      // store Login Credentials
      dispatch(
        saveAuthData({
          authToken: result?.data?.access_token || '',
          refreshToken: result?.data?.refresh_token || '',
          tokenTime: Date.now(),
          isAuthenticated: true,
        })
      );
      dispatch(
        saveUserData({
          role: result?.data?.role ? result?.data?.role : "",
          username: result?.data?.username ? result?.data?.username : "",
          email: result?.data?.email ? result?.data?.email : "",
          name: result?.data?.name ? result?.data?.name : "",
        })
      );
      sessionStorage.setItem('session', uuid());
    }else{
      toastUpdate("Error", 'Please login again!', true);
    }
    }
  };


useEffect(() => {
  if (isAuthenticated) {
    navigate("/coreservice/dashboard");
  }
}, [isAuthenticated, navigate]);
  return (
    <>
      {noticeModal && (
        <NoticeModal
          noticeModal={noticeModal}
          noticeModalHeader={noticeModalHeaderMsg}
          noticeModalErrMsg={noticeModalErrMsg}
          closeModal={closeNoticeModal}
        />
      )}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </>
  );
};

export default AutoLogin;